import React from "react";
import "./SectionSix.scss";
import img1 from "../../../../../Assets/Images/SuperCondria/section6/Benefit_0.png";
import img2 from "../../../../../Assets/Images/SuperCondria/section6/Benefit_1.png";
import img3 from "../../../../../Assets/Images/SuperCondria/section6/Benefit_2.png";
import img4 from "../../../../../Assets/Images/SuperCondria/section6/Benefit_3.png";
import img5 from "../../../../../Assets/Images/SuperCondria/section6/Benefit_4.png";
import { useTranslation } from "react-i18next";

const itemList = [
  {
    index: 0,
    img: img1,
    heading: "SectionSix_Des_1",
    desc: "SectionSix_Des_1_1",
  },
  {
    index: 1,
    img: img2,
    heading: "SectionSix_Des_2",
    desc: "SectionSix_Des_2_1",
  },
  {
    index: 2,
    img: img3,
    heading: "SectionSix_Des_3",
    desc: "SectionSix_Des_3_1",
  },
  {
    index: 3,
    img: img4,
    heading: "SectionSix_Des_4",
    desc: "SectionSix_Des_4_1",
  },
  {
    index: 4,
    img: img5,
    heading: "SectionSix_Des_5",
    desc: "SectionSix_Des_5_1",
  },
];

const SectionSix = () => {
  const { t, i18n } = useTranslation(["des"]);
  return (
    <div className="section-six_v2 bg-main">
      <div className="section-six_v2-container border-section container">
        <h3 className="h3">{t("SectionSix_Des_0")}</h3>
        <div className="section-six_v2-content">
          {itemList.map((item) => (
            <div key={item.index} className="section-six_v2-item">
              <img src={item.img} alt="img section6" />
              <h4>{t(item.heading)}</h4>
              <p>{t(item.desc)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionSix;
